import React, { useState, useEffect } from 'react';
import { getContacts } from './../API';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Tag, Icon, Button, Row, Col, Input, Skeleton, Table, Tooltip } from 'antd';
import CustomAvatar from './../components/customAvatar';
import { flexCenterRight } from './../theme';
import { navigate } from "@reach/router"

const { Search } = Input;

function Contacts() {
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const contacts = useMappedState(state => state.contacts);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    async function fetchData() {
      const response = await getContacts(session.authToken);
      dispatch({type: "INIT_CONTACTS", payload: response.data.contacts});
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "4"});
    fetchData();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: '',
      width: '1%',
      key: 'bothSide',
      render: (contact) => <>
      {
        contact.bothSide ? (
          <div>
            <Tooltip title="This contact is candidate as well" >
              <Icon type="swap" />
            </Tooltip>
          </div>
        ) : null
      }
      </>
    },
    {
      title: '',
      width: '1%',
      key: 'avatar',
      render: (contact) => 
      <CustomAvatar
        colourCode={contact.firstname.charAt(0).toLowerCase()}
        char={`${contact.firstname.charAt(0).toUpperCase()}${contact.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        src={contact.avatar} 
      />
    },
    {
      title: '',
      width: '2%',
      dataIndex: 'salutation',
      key: 'salutation',
    },
    {
      title: 'Name',
      width: '10%',
      dataIndex: 'fullname',
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
      key: 'fullname',
    },
    {
      title: 'Client',
      width: '9%',
      sorter: (a, b) => a.client.name.localeCompare(b.client.name),
      render: (contact) => <div>
        <Tag>{contact.client.name}</Tag>
      </div>
    },
    {
      title: 'Client City',
      width: '9%',
      sorter: (a, b) => a.client.name.localeCompare(b.client.name),
      render: (contact) => <div>
        {contact.client.address.city}
      </div>
    },
    {
      title: 'Position',
      width: '9%',
      sorter: (a, b) => a.position.localeCompare(b.position),
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Department',
      width: '9%',
      sorter: (a, b) => a.department.localeCompare(b.department),
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: '',
      width: '8%',
      render: (contact) => <div style={flexCenterRight}>
        <Button disabled={!contact.linkedin || contact.linkedin === ""}
          size="small" onClick={() => {
          if (contact.linkedin && contact.linkedin !== "") {
            window.open(contact.linkedin, '_blank');
          }
          else {
            dispatch({type: "OPEN_MSG_MODAL", payload: "linkedin is not available"});
          }
        }}><Icon type="linkedin" /></Button>
        &nbsp;&nbsp;&nbsp;
        <Button size="small" onClick={() => {
          navigate(`/contacts/${contact.id}`)
        }}><Icon type="plus" /></Button>
      </div>
    }
  ];

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>
      <Row>
        <Col span={24}>
          <Search
            placeholder="Search"
            onChange={e => setSearch(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>
      </Row>
      <br/>
      <Table
        columns={columns}
        dataSource={
          search === "" ?
          contacts.map(i => {
            return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          })
          :
          contacts.map(i => {
            return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          }).filter(e => 
            e.fullname.toLowerCase().includes(search.toLowerCase()) ||
            e.client.name.toLowerCase().includes(search.toLowerCase()) ||
            e.position.toLowerCase().includes(search.toLowerCase()) ||
            e.department.toLowerCase().includes(search.toLowerCase())
            )
        }
        rowKey="id"
      />
    </div>

  );
}

export default Contacts;